<template>
  <div class="page__container">
    <div v-if="count && count > 0" class="count col-6">
      {{ $t("lines") }}
      {{ setMinLineLimit(activePage, limit) }}
      {{ $t("pagination.to") }}
      {{ setMaxLineLimit(activePage, count, limit) }}
      {{ $t("pagination.on") }} {{ count }}
    </div>
    <div v-if="totalNumberOfPage > 1" class="page">
      <button :disabled="activePage === 1" class="btn" type="button" @click="changePage(activePage - 1)">
        <FontAwesomeIcon icon="fa-light fa-chevron-left" />
      </button>
      <button :class="'btn' + (1 === activePage ? ' active' : '')" type="button" @click="changePage(1)">1</button>
      <button v-if="activePage > 4" :disabled="true" class="btn" type="button">...</button>
      <template v-for="n in totalNumberOfPage" :key="n">
        <button
          v-if="showButton(n)"
          :class="'btn' + (n === activePage ? ' active' : '')"
          type="button"
          @click="changePage(n)"
        >
          {{ n }}
        </button>
      </template>
      <button v-if="activePage <= totalNumberOfPage - 4" :disabled="true" class="btn" type="button">...</button>
      <button
        :class="'btn' + (totalNumberOfPage === activePage ? ' active' : '')"
        type="button"
        @click="changePage(totalNumberOfPage)"
      >
        {{ totalNumberOfPage }}
      </button>
      <button
        :disabled="activePage === totalNumberOfPage"
        class="btn"
        type="button"
        @click="changePage(activePage + 1)"
      >
        <FontAwesomeIcon icon="fa-light fa-chevron-right" />
      </button>
    </div>
  </div>
</template>

<script>
import { sortManager } from "@/services/utilities/sort-manager";

export default {
  name: "PaginationDataTableComponent",
  components: {},
  props: {
    totalNumberOfPage: {
      type: Number,
      required: true,
    },
    activePage: {
      type: Number,
      required: true,
    },
    limit: {
      type: Number,
      required: true,
    },
    count: {
      type: Number,
      required: true,
    },
  },
  emits: [],
  methods: {
    showButton(n) {
      let mobile = window.innerWidth < 768;
      let rightOffset = 5;
      let leftOffset = 3;
      let delta = 2;

      if (this.activePage >= this.totalNumberOfPage - leftOffset) {
        leftOffset = mobile ? 2 : 4;
      }

      if (n === 1 || n === this.totalNumberOfPage) {
        return false;
      }
      if (this.activePage < rightOffset && n <= rightOffset) {
        return true;
      } else if (this.activePage > this.totalNumberOfPage - leftOffset && n >= this.totalNumberOfPage - leftOffset) {
        return true;
      } else if (this.activePage >= rightOffset && n < this.activePage + delta && n > this.activePage - delta) {
        return true;
      }
    },

    setMinLineLimit(activePage, limit) {
      return sortManager.setMinLineLimit(activePage, limit);
    },

    setMaxLineLimit(activePage, maxResult, limit) {
      return sortManager.setMaxLineLimit(activePage, maxResult, limit);
    },

    changePage(n) {
      this.$emit("changePage", n);
    },
  },
};
</script>

<style lang="scss" scoped>
.page {
  display: flex;
  justify-content: end;

  &__container {
    display: flex;
    align-items: center;
    justify-content: space-between;

    @include up-to-md {
      flex-direction: column;
      justify-content: center;
    }
  }

  .btn {
    border: none;
    width: 40px;
    height: 40px;

    &:hover,
    &.active {
      background-color: $blue;
      color: $white;
    }
  }

  .btn + .btn {
    margin-left: 10px;
  }
}

.count {
  color: $light-grey;
  font-size: 12px;
  padding: 20px 9px 20px 0;

  @include up-to-md {
    text-align: center;
  }
}
</style>
